import { RequestHelper } from "../Helpers/RequestHelper.js";

export class PmDealersite {
    constructor(config) {
        this.config = config;
    }

    getRootURL() {
        if (this.config.production) {
            return location.origin;
        }
        return "http://dealersite.loc";
    }

    getURL(route) {        
        return this.getRootURL() + route;
    }

    getCurrentUrl() {
        return window.location.href;
    }

    getAccessoriesByVin(vin, successCallback, errorCallback) {
        const route = '/wp-content/plugins/pm-motors-plugin/modules/inventory/php/endpoints/AccessoryEndpoint.php';
        RequestHelper.ajax("GET", this.getURL(route), { vin }, (response) => {
            try {
                let parsed = JSON.parse(response) || {};
                const accessories = Object.fromEntries(
                    Object.entries(parsed).filter(([_, acc]) => acc && acc.enabled)
                );
                successCallback(accessories);
            } catch (e) {
                errorCallback(e);
            }
        }, errorCallback);
    }


    // Method for getting CCPA and TCPA
    getCCPATCPADescriptions(successCallback, errorCallback) {
        RequestHelper.ajax("GET", this.getURL("/index.php?pmGetDescriptions=all"), {}, successCallback, errorCallback);
    }

    // send twilio message
    sendTwilioMsg(data, successCallback, errorCallback) {
        RequestHelper.ajax("post", this.getURL("/pm/sendTwilio"), data, successCallback, errorCallback);
    }
}
